import React from 'react';
import { chakra, Container } from '@chakra-ui/react';
import HubspotForm from 'react-hubspot-form';

const SubBox = chakra(Container, {
  baseStyle: {
    transform: 'rotate(-1deg)',
    fontSize: '1rem',
    '.label-email-b8e37bbd-73db-40d3-bf95-eb0a043990fa, label': {
      textAlign: 'left',
      marginBottom: '1rem',
      fontSize: '1rem',
    },
  },
});

/** A section that allows users to subscribe to blog emails */
const BlogSubscribe = (): JSX.Element => (
  <SubBox p={['8', '5']} maxWidth="550px" m="auto" variant="lightGreySection">
    <h4>Subscribe below to get future posts from SaferMe</h4>
    <p>
      We send out emails once a month. We won't share your email with anyone.
    </p>
    <HubspotForm
      portalId="4330484"
      formId="b8e37bbd-73db-40d3-bf95-eb0a043990fa"
      // onSubmit={() => console.log('Submit!')}
      // onReady={(form) => console.log('Form ready!', form)}
      loading={<div>Loading...</div>}
    />
  </SubBox>
);

export default BlogSubscribe;
